import { ButtonProps } from 'atomic/button/button.interface';
import classNames from 'classnames';

import './button.scss';

export default function getButtonClasses(
    props: Pick<ButtonProps, 'color' | 'block' | 'uppercase' | 'size'| 'weight' | 'noWrap' | 'disabled' | 'border' | 'className'>
): string {
    const buttonClass = classNames({
        ['button']: true,
        [`button--${props.color}`]: true,
        [`button--${props.size}`]: true,
        [`button--fw-${props.weight}`]: true,
        'button--block': props.block,
        'button--nowrap': props.noWrap,
        'button--uppercase': props.uppercase,
        'button--disabled': props.disabled,
        [`button--border-${props.color}`]: props.border,
        [`${props.className}`]: !!props.className
    });

    return buttonClass;
}
